<div class="search-messages">
    <div class="search-messages__title">Сообщения</div>
    <button
        *ngFor="let message of messages"
        class="search-messages__item"
        type="button"
        (click)="messageSelected.emit(message)"
    >
        <span class="search-messages__item-session">{{ message.sessionTitle }}</span>
        <span class="search-messages__item-text">{{ message.text }}</span>
        <span class="search-messages__item-date">{{ message.createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
    </button>
</div>
